import { render, staticRenderFns } from "./BookingMobileButtons.vue?vue&type=template&id=145b301e"
import script from "./BookingMobileButtons.vue?vue&type=script&lang=js"
export * from "./BookingMobileButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports